import { render } from "./DebugNotesCollector.vue?vue&type=template&id=8e1dfbf4&scoped=true"
import script from "./DebugNotesCollector.vue?vue&type=script&lang=js"
export * from "./DebugNotesCollector.vue?vue&type=script&lang=js"

import "./DebugNotesCollector.vue?vue&type=style&index=0&id=8e1dfbf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e1dfbf4"]])

export default __exports__